<app-temp-modal-cadastro #modalCadastro (closed)="onClose()" [textHeader]="'Vincular Eventos Bancários'"
  [customClassMobile]="'allScreen'" [customClassContentMobile]="'allScreen'">
  <app-dim-datatable #table [data]="bancoEventos" [loading]="loading['table']" [selectable]="true" [columns]="colunas"
    [selecionados]="selecionados" [showPagination]=false [showInfoMobile]=false>
  </app-dim-datatable>

  <button class="btn btn-primary" type="button" (click)="salvar()"><i class="ti ti-plus"></i> Salvar</button>
</app-temp-modal-cadastro>